import { createContext, useContext, useState } from "react";

const pharmacyContext = createContext();

/** Logged-in lab user (`safeUser`) already stored by login as `currentLab`. */
export const readStoredLabUser = () => {
	try {
		const saved = localStorage.getItem("currentLab");
		return saved ? JSON.parse(saved) : null;
	} catch {
		return null;
	}
};

export const PharmacyProvider = (props) => {
	const [currentLab, setCurrentLab] = useState(() => readStoredLabUser());

		return (
			<pharmacyContext.Provider value={{ ...props, currentLab, setCurrentLab}}>
				{props.children}
			</pharmacyContext.Provider>
		)
}

export const useLab = () => useContext(pharmacyContext);